import { Directive, HostListener, Input, OnInit, inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { showAuthDialog } from './auth-wall-dialog.component';

@Directive({
  selector: '[bcAuthWall]',
  standalone: false,
})
export class AuthWallDirective implements OnInit {
  @Input() bcAuthWall: AuthWallParams;
  enabled: boolean;

  showAuthDialog = showAuthDialog();
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.enabled = this.bcAuthWall.enabled === undefined ? true : this.bcAuthWall.enabled;
  }

  private checkPreviewMode(event: Event): void {
    if (this.authService.isInPreviewMode() && this.enabled) {
      this.showAuthDialog();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent): void {
    this.checkPreviewMode(event);
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.code !== 'Space') {
      return;
    }
    this.checkPreviewMode(event);
  }
}

export interface AuthWallParams {
  enabled: boolean;
  trackingLabel: string;
}
